import { c as _c } from "react/compiler-runtime";
import loadable from '@loadable/component';
import React, { useEffect } from 'react';
import AboveTheFoldServerRenderer from 'components/essentials/AboveTheFoldServerRenderer';
import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';
import useIsBrowser from 'hooks/useIsBrowser';
import useCuralate from 'hooks/useCuralate';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
// CON-7309: Temporarily removed to help isolate cause of performance issues
// import BrowserOnly from 'components/consumer/BrowserOnly';

const CRL8_CONTAINER_ID = 'product';
const RecentlyViewed = loadable(() => import('components/consumer/recently-viewed'));

// CON-7309: Temporarily removed to help isolate cause of performance issues
// const RecommendedForYouCarousel = loadable(() =>
//   import('components/consumer/ProductCardCarousel/RecommendedForYouCarousel')
// );

const PDPFooterInner = () => {
  const $ = _c(14);
  const {
    data
  } = usePDPBasicDetails();
  const isBrowser = useIsBrowser();
  const {
    createExperience,
    destroyExperience
  } = useCuralate();
  const sku = data?.sku;
  let t0;
  let t1;
  if ($[0] !== createExperience || $[1] !== destroyExperience || $[2] !== isBrowser || $[3] !== sku) {
    t0 = () => {
      if (!isBrowser || !sku) {
        return;
      }
      createExperience({
        containerId: CRL8_CONTAINER_ID,
        filter: `productId:${sku}`
      });
      return () => destroyExperience({
        containerId: CRL8_CONTAINER_ID
      });
    };
    t1 = [isBrowser, sku, createExperience, destroyExperience];
    $[0] = createExperience;
    $[1] = destroyExperience;
    $[2] = isBrowser;
    $[3] = sku;
    $[4] = t0;
    $[5] = t1;
  } else {
    t0 = $[4];
    t1 = $[5];
  }
  useEffect(t0, t1);
  let t2;
  if ($[6] !== isBrowser || $[7] !== sku) {
    t2 = !!isBrowser && <div data-crl8-container-id={CRL8_CONTAINER_ID} data-crl8-filter={`productId:${sku}`} />;
    $[6] = isBrowser;
    $[7] = sku;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const t3 = data?.id;
  let t4;
  if ($[9] !== t3) {
    t4 = <AboveTheFoldServerRenderer disableOnServer={true}><RecentlyViewed currentPDPProduct={t3} /></AboveTheFoldServerRenderer>;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t2 || $[12] !== t4) {
    t5 = <>{t2}{t4}</>;
    $[11] = t2;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};
const PDPFooter = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <SuspenseWithLoader><PDPFooterInner {...props} /></SuspenseWithLoader>;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export default PDPFooter;